import { render } from "./CoursePreview.vue?vue&type=template&id=0e2d9312&scoped=true"
import script from "./CoursePreview.vue?vue&type=script&lang=js"
export * from "./CoursePreview.vue?vue&type=script&lang=js"

import "./CoursePreview.vue?vue&type=style&index=0&id=0e2d9312&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2d9312"]])

export default __exports__